import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";


export default {
    namespaced: true,
    state: {
        instructionsList: [],
        instructions: {},
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.instructionsList.findIndex(i => i.id === id)
    },
    mutations: {
        SetItems: (state, data) => state.instructionsList = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SetItem: (state, viewData) => state.instructions = viewData,
        ADD: (state, addedData) => state.instructionsList.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.instructionsList.splice(index, 1, updateData),
        DELETE: (state, index) => state.instructionsList.splice(index, 1),
    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                const response = await dataService.instructions.getAll(paramsString);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SetItems', response.data.instructions);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getDetails({ commit }, id) {
            startLoading()
            try {
                commit('SetItem', {});
                const response = await dataService.instructions.getDetails(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SetItem', response.data.instruction);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        }, 
         async getForEdit(_, id) {
            startLoading()
            try {
                const response = await dataService.instructions.getForEdit(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                return Promise.resolve(response.data.instruction);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async add({ commit }, payload) {
            startLoading()
            try {
                const response = await dataService.instructions.add(payload);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);
                commit('ADD', response.data.instructions);
            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        async edit({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.instructions.edit(id,payload);

                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.instructions });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);

            }
        },
        async getForPrint(_, id) {
                    startLoading()
                    try {
                        const response = await dataService.instructions.getForPrint(id);
        
                        stopLoading()
                        if (!response.data.statusCode) {
                            showAlert(serverErrorMessage);
                            return;
                        }
                        return Promise.resolve(response.data.instructions);
        
                    } catch (error) {
                        stopLoading()
                        catchHandler(error);
                    }
                },
        async delete({ commit, getters }, id) {
            startLoading()
            try {
                const response = await dataService.instructions.delete(id);

                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('DELETE', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
    },
};
